import { Controller } from '@hotwired/stimulus'

// Поле «Клуб» в конструкторе турниров: чипы избранных клубов + подсказки.
// Сервер (/account/clubs/suggest) сначала ищет по городам, где у
// пользователя есть избранные клубы, иначе глобально — тогда в подсказке
// «Клуб · Город · Страна». То же поле у матча («Где»). У расписания тренера
// своё поле — training_club_controller.js.
export default class TournamentClubController extends Controller {
  // id — необязательное скрытое поле (форма матча): туда пишется id клуба из
  // подсказки; ручная правка названия его обнуляет.
  static targets = ['input', 'dropdown', 'id']
  static values = { url: String }

  connect() {
    this.onDocumentClick = (event) => {
      if (!this.element.contains(event.target)) this.close()
    }
    document.addEventListener('click', this.onDocumentClick)
  }

  disconnect() {
    document.removeEventListener('click', this.onDocumentClick)
    clearTimeout(this.timer)
  }

  pickChip(event) {
    this.pick(event.params.name)
  }

  // Город клуба — событием: форма матча подставляет его в поле «Город»
  // (match_city_controller.js#fillFromClub). У чипов ни id, ни города нет.
  pick(name, city = null, id = null) {
    this.inputTarget.value = name
    if (this.hasIdTarget) this.idTarget.value = id || ''
    this.close()
    if (city) {
      this.element.dispatchEvent(
        new CustomEvent('tournament-club:picked', {
          bubbles: true,
          detail: { city }
        })
      )
    }
  }

  search() {
    if (this.hasIdTarget) this.idTarget.value = ''
    clearTimeout(this.timer)
    const query = this.inputTarget.value.trim()
    if (query.length < 2) {
      this.close()
      return
    }
    this.timer = setTimeout(() => this.fetchSuggestions(query), 300)
  }

  async fetchSuggestions(query) {
    // Отбрасываем устаревшие ответы: медленный запрос не должен
    // перерисовать подсказки поверх результатов более позднего ввода.
    const requestId = (this.lastRequestId = (this.lastRequestId || 0) + 1)
    try {
      const url = `${this.urlValue}?q=${encodeURIComponent(query)}`
      const response = await fetch(url, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      })
      if (requestId !== this.lastRequestId || !response.ok) return

      const data = await response.json()
      if (requestId !== this.lastRequestId) return
      this.render(data.suggestions || [])
    } catch {
      this.close()
    }
  }

  render(suggestions) {
    if (!suggestions.length) {
      this.close()
      return
    }

    this.dropdownTarget.innerHTML = ''
    suggestions.forEach(({ id, name, label, city }) => {
      const item = document.createElement('button')
      item.type = 'button'
      item.className = 'tournament-club-suggestion'
      item.textContent = label
      item.addEventListener('click', () => this.pick(name, city, id))
      this.dropdownTarget.appendChild(item)
    })
    this.dropdownTarget.classList.remove('hidden')
  }

  close() {
    this.dropdownTarget.classList.add('hidden')
    this.dropdownTarget.innerHTML = ''
  }
}
